<template>
  <div>
    <table>
      <tr>
        <td>ID:</td>
        <td>{{ account.id }}</td>
      </tr>
      <tr>
        <td>Type:</td>
        <td>
          <select type="text" v-model="type">
            <option value="demo">Demo</option>
            <option value="trial">Trial</option>
            <option value="assessment">Assessment</option>
            <option value="monitoring">Monitoring</option>
            <option value="benchmark">Benchmark</option>
            <option value="cei">CEI</option>
            <!-- Deprecated -->
            <option value="on_demand" disabled>On Demand</option>
            <option value="full_support" disabled>Full Support</option>
            <option value="self_managed" disabled>Self Managed</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Tags:</td>
        <td><input type="text" v-model="tags"/></td>
      </tr>
      <tr>
          <td>API key:</td>
          <td v-if="account.api_keys">{{account.api_keys[0].key}}</td>
        </tr>
      <tr>
        <td>Name:</td>
        <td><input type="text" v-model="name"/></td>
      </tr>
      <tr>
        <td>Sector:</td>
        <td>
          <select type="text" v-model="sector">
            <option value="energy">Energy</option>
            <option value="materials">Materials</option>
            <option value="industrials">Industrials</option>
            <option value="consumer_discretionary">Consumer Discretionary</option>
            <option value="consumer_staples">Consumer Staples</option>
            <option value="health_care">Health Care</option>
            <option value="financials">Financials</option>
            <option value="information_technology">Information Technology</option>
            <option value="telecommunication_services">Telecommunication Services</option>
            <option value="utilities">Utilities</option>
            <option value="real_estate">Real Estate</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Continent:</td>
        <td>
          <select type="text" v-model="continent">
            <option value="asia">Asia</option>
            <option value="africa">Africa</option>
            <option value="australia">Australia</option>
            <option value="europe">Europe</option>
            <option value="north_america">North America</option>
            <option value="south_america">South America</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Employees:</td>
        <td><input type="number" min="0" v-model="employees"/></td>
      </tr>
      <tr>
        <td>Company name:</td>
        <td><input type="text" min="0" v-model="company_name"/></td>
      </tr>
      <tr>
        <td>Company address:</td>
        <td><input type="text" min="0" v-model="company_address"/></td>
      </tr>
      <tr>
        <td>Company country:</td>
        <td><input type="text" min="0" v-model="company_country"/></td>
      </tr>
      <tr>
        <td>Company revenue:</td>
        <td><input type="text" min="0" v-model="company_revenue"/></td>
      </tr>
      <tr>
        <td>Contact person name:</td>
        <td><input type="text" min="0" v-model="contact_person_name"/></td>
      </tr>
      <tr>
        <td>Contact person position:</td>
        <td><input type="text" min="0" v-model="contact_person_position"/></td>
      </tr>
      <tr>
        <td>Contact person email:</td>
        <td><input type="text" min="0" v-model="contact_person_email"/></td>
      </tr>
      <tr>
        <td>Contact person phone number:</td>
        <td><input type="text" min="0" v-model="contact_person_phonenumber"/></td>
      </tr>
    </table>
    <button @click="cancel()">Cancel</button>
    <button @click="save()">Save</button>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

td input {
    min-width: 10px;
    max-width: 100%;
    width: 100%;
}

</style>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      name: this.account.name,
      sector: this.account.sector,
      continent: this.account.continent,
      employees: this.account.employees,
      type: this.account.type,
      tags: this.account.tags,
      company_name: this.account.company_name,
      company_address: this.account.company_address,
      company_country: this.account.company_country,
      company_revenue: this.account.company_revenue,
      contact_person_name: this.account.contact_person_name,
      contact_person_position: this.account.contact_person_position,
      contact_person_email: this.account.contact_person_email,
      contact_person_phonenumber: this.account.contact_person_phonenumber
    }
  },
  watch: {
    account () {
      this.name = this.account.name
      this.sector = this.account.sector
      this.continent = this.account.continent
      this.employees = this.account.employees
      this.type = this.account.type
      this.tags = this.account.tags
      this.company_name = this.account.company_name
      this.company_address = this.account.company_address
      this.company_country = this.account.company_country
      this.company_revenue = this.account.company_revenue
      this.contact_person_name = this.account.contact_person_name
      this.contact_person_position = this.account.contact_person_position
      this.contact_person_email = this.account.contact_person_email
      this.contact_person_phonenumber = this.account.contact_person_phonenumber
    }
  },
  methods: {
    cancel () {
      this.name = this.account.name
      this.sector = this.account.sector
      this.continent = this.account.continent
      this.employees = this.account.employees
      this.type = this.account.type
      this.tags = this.account.tags
      this.company_name = this.account.company_name
      this.company_address = this.account.company_address
      this.company_country = this.account.company_country
      this.company_revenue = this.account.company_revenue
      this.contact_person_name = this.account.contact_person_name
      this.contact_person_position = this.account.contact_person_position
      this.contact_person_email = this.account.contact_person_email
      this.contact_person_phonenumber = this.account.contact_person_phonenumber
    },
    save () {
      var params = {}
      if (this.name !== this.account.name) params['name'] = this.name
      if (this.sector !== this.account.sector) params['sector'] = this.sector
      if (this.continent !== this.account.continent) params['continent'] = this.continent
      if (this.employees !== this.account.employees) params['employees'] = this.employees
      if (this.type !== this.account.type) params['type'] = this.type
      if (this.tags !== this.account.tags) params['tags'] = this.tags
      if (this.company_name !== this.account.company_name) params['company_name'] = this.company_name
      if (this.company_address !== this.account.company_address) params['company_address'] = this.company_address
      if (this.company_country !== this.account.company_country) params['company_country'] = this.company_country
      if (this.company_revenue !== this.account.company_revenue) params['company_revenue'] = this.company_revenue
      if (this.contact_person_name !== this.account.contact_person_name) params['contact_person_name'] = this.contact_person_name
      if (this.contact_person_position !== this.account.contact_person_position) params['contact_person_position'] = this.contact_person_position
      if (this.contact_person_email !== this.account.contact_person_email) params['contact_person_email'] = this.contact_person_email
      
      if (this.contact_person_phonenumber !== this.account.contact_person_phonenumber)
        params['contact_person_phonenumber'] = this.contact_person_phonenumber

      this.$store.dispatch('updateAccount', {
        account: this.account, 
        params: params
      })
    }
  }
}
</script>
